export default __webpack_public_path__ + "495a93b866ded1b3148326144a1f16fb.svg";